import React from "react";
import { Link } from "react-router-dom";
import { Compass, Layers, Pencil, CalendarDays, Filter, LineChart, Sparkles, GitBranch, ArrowRight } from "lucide-react";

const LAYERS = [
  {
    key: "estrategia", label: "1. Estratégia", desc: "Onde a marca está e pra onde vai",
    modules: [
      { to: "/posicionamento", label: "Posicionamento", desc: "Wizard de 14 etapas", icon: Compass },
    ],
  },
  {
    key: "operacao", label: "2. Operação", desc: "Como o dia-a-dia funciona",
    modules: [
      { to: "/workspace", label: "Workspace", desc: "7 camadas do cliente", icon: Layers },
    ],
  },
  {
    key: "producao", label: "3. Produção", desc: "O que você publica",
    modules: [
      { to: "/conteudo", label: "Conteúdo", desc: "Roteiro em 6 passos", icon: Pencil },
      { to: "/calendario", label: "Calendário", desc: "Editorial semanal + mix", icon: CalendarDays },
    ],
  },
  {
    key: "resultado", label: "4. Resultado", desc: "O que você mede",
    modules: [
      { to: "/funil", label: "Funil & Métricas", desc: "AARRR + gargalos", icon: Filter },
      { to: "/performance", label: "Performance", desc: "KPIs, tendência, breakdown", icon: LineChart },
    ],
  },
  {
    key: "meta", label: "5. Meta", desc: "Visualização do sistema",
    modules: [
      { to: "/frameworks", label: "Frameworks", desc: "Roda, momento, funil, mix", icon: Sparkles },
    ],
  },
];

export default function SystemMap() {
  return (
    <div className="p-6 lg:p-10" data-testid="system-map-page">
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-1">
          <GitBranch size={16} className="grad-text" />
          <div className="font-mono text-[10px] uppercase tracking-widest grad-text font-bold">// arquitetura</div>
        </div>
        <h1 className="text-3xl font-extrabold">Mapa do Sistema</h1>
        <p className="text-muted text-sm mt-1">Como os módulos se conectam. Estratégia alimenta operação, que produz conteúdo, que gera resultado.</p>
      </div>

      <div className="space-y-6">
        {LAYERS.map((layer, i) => (
          <div key={layer.key} className="relative" data-testid={`layer-${layer.key}`}>
            <div className="flex items-baseline gap-3 mb-3">
              <div className="font-mono text-[10px] uppercase tracking-widest grad-text font-bold">{layer.label}</div>
              <div className="text-xs text-muted">{layer.desc}</div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
              {layer.modules.map((m) => {
                const Icon = m.icon;
                return (
                  <Link key={m.to} to={m.to} className="card hover-lift p-5 flex items-center gap-4" data-testid={`module-${m.to.slice(1)}`}>
                    <div className="w-12 h-12 rounded-xl grad-bg flex items-center justify-center flex-shrink-0">
                      <Icon size={20} className="text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold">{m.label}</div>
                      <div className="text-xs text-muted mt-0.5">{m.desc}</div>
                    </div>
                    <ArrowRight size={16} className="text-muted flex-shrink-0" />
                  </Link>
                );
              })}
            </div>
            {i < LAYERS.length - 1 && (
              <div className="flex justify-center my-1">
                <div className="w-px h-6" style={{ background: "linear-gradient(to bottom, var(--border), transparent)" }} />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-8 card-2 p-4 text-xs text-muted">
        💡 <strong>Como o sistema flui:</strong> defina o posicionamento → estruture o workspace do cliente → produza conteúdo com roteiro persuasivo → planeje no calendário → acompanhe funil e performance → visualize tudo em Frameworks. Cada módulo alimenta o próximo.
      </div>
    </div>
  );
}
